import { createApp } from "vue";

import Contracts from "./Contracts.vue";


const handle = "almero-vue-contracts";
const mountEls = document.querySelectorAll(`.${handle}`);

mountEls.forEach((mountEl) => {
    let props = {};
    try {
        props = JSON.parse(mountEl.dataset.rootProps);
    }
    catch (e) {
        console.error(e);
    }
    const app = createApp(
        Contracts, {
            ...props,
        }
    );
    app.mount(mountEl);
});